import { render, staticRenderFns } from "./ProductGroupSelect.vue?vue&type=template&id=5968045c&scoped=true&"
import script from "./ProductGroupSelect.vue?vue&type=script&lang=js&"
export * from "./ProductGroupSelect.vue?vue&type=script&lang=js&"
import style0 from "./ProductGroupSelect.vue?vue&type=style&index=0&id=5968045c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5968045c",
  null
  
)

export default component.exports